module.exports = __webpack_public_path__ + "images/repco-white.jpg";